import { ApolloLink } from '@apollo/client';
import { appStateSelectors, reduxStore } from 'src/utilities/redux';

export const addHeadersLink = new ApolloLink((operation, forward) => {
  const state = reduxStore.getState();
  const authorization = appStateSelectors.getAuthorizationToken(state);
  const clientId = appStateSelectors.getClientId(state);

  operation.setContext({
    headers: {
      authorization,
      'X-GraphQL-Deduplicate': true,
      'X-Client-Id': clientId,
    },
  });
  return forward(operation);
});
